export const CgToggle = ({
  offLabel,
  onLabel,
  toggled,
  onClick,
  loading = false,
  disabled = false,
  sizing = 'md', // 'sm', 'md', 'lg'
  caption,
}) => {
  const isDisabled = loading || disabled;
  const hasLabels = offLabel || onLabel;

  // Size configurations
  const sizeConfig = {
    sm: {
      track: 'w-8 h-4',
      thumb: 'w-3 h-3',
      thumbPosition: 'left-0.5 top-0.5',
      thumbTranslate: 'peer-checked:translate-x-4',
      spinner: 'h-2 w-2',
    },
    md: {
      track: 'w-10 h-6',
      thumb: 'w-4 h-4',
      thumbPosition: 'left-1 top-1',
      thumbTranslate: 'peer-checked:translate-x-4',
      spinner: 'h-3 w-3',
    },
    lg: {
      track: 'w-12 h-7',
      thumb: 'w-5 h-5',
      thumbPosition: 'left-1 top-1',
      thumbTranslate: 'peer-checked:translate-x-5',
      spinner: 'h-4 w-4',
    },
  };

  const config = sizeConfig[sizing] || sizeConfig.md;

  return (
    <div
      className={`flex items-center ${hasLabels ? 'space-x-4 px-4' : ''} ${isDisabled ? 'opacity-60' : ''}`}
    >
      {offLabel && (
        <span className="xl:text-base text-sm font-semibold text-secondaryColor">{offLabel}</span>
      )}
      <label
        className={`cg-toggle inline-flex items-center ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <span className="relative inline-flex shrink-0">
          <input
            className="cg-toggle-input sr-only peer"
            type="checkbox"
            checked={toggled}
            onChange={() => !isDisabled && onClick(!toggled)}
            disabled={isDisabled}
          />
          <span
            className={`cg-toggle-span ${config.track} bg-gray-400 rounded-full peer-checked:bg-primaryColor peer-focus-visible:ring-2 peer-focus-visible:ring-primaryColor peer-focus-visible:ring-offset-2 transition-all ${loading ? 'animate-pulse' : ''}`}
          ></span>
          {loading ? (
            <span
              className={`absolute ${config.thumb} bg-white rounded-full ${config.thumbPosition} flex items-center justify-center`}
              style={{ transform: toggled ? 'translateX(1rem)' : 'translateX(0)' }}
            >
              <svg
                className={`animate-spin ${config.spinner} text-primaryColor`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            </span>
          ) : (
            <span
              className={`absolute ${config.thumb} bg-white rounded-full transform transition-all ${config.thumbTranslate} ${config.thumbPosition}`}
            ></span>
          )}
        </span>
        {caption ? <span className="ml-2 select-none">{caption}</span> : null}
      </label>
      {onLabel && (
        <span className="xl:text-base text-sm font-semibold text-secondaryColor">{onLabel}</span>
      )}
    </div>
  );
};
